export default __webpack_public_path__ + "img/special-offer-long.d35ab2f271fa756e772fd897813fb24f.png";